import { TableField } from '../../../Canvas/Table'

type Field = {
  name: string
  type: string
}

export const parseTableFields = (
  fields: Record<string, Field> | undefined
): TableField[] => {
  if (!fields) {
    return []
  }

  const newFields = []

  for (const fieldId in fields) {
    if (fieldId) {
      newFields.push({
        fieldId,
        label: fields[fieldId]?.name ?? '',
        type: fields[fieldId]?.type ?? '',
      })
    }
  }

  return newFields
}
